import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { UsercentricsService } from './usercentrics.service';

export function usercentricsInitializerFn(): void | Observable<unknown> | Promise<unknown> {
    const usercentrics = inject(UsercentricsService);
    return usercentrics.init();
}
